import classnames from 'classnames/bind'
import React from 'react'

import RichText, { RichTextBlock } from '~/components/RichText'

import { useStyle } from '~/providers/StyleProvider'

import css from './styles.module.scss'

const cx = classnames.bind(css)

export interface ArticleTextProps {
  className?: string
  text?: RichTextBlock[]
}

function ArticleText({ className, text }: ArticleTextProps) {
  const gridStyle = useStyle({ grid: 'base-grid' })
  const textStyle = useStyle({ textPreset: 'rich-text-variant-1' })
  return (
    <div className={cx(css.ArticleText, className)}>
      <div className={gridStyle}>
        {text && <RichText className={cx(css.text, textStyle)} render={text} />}
      </div>
    </div>
  )
}

ArticleText.defaultProps = {}

export default ArticleText
